import {httpClient, handleError} from './';

export const _getImageRegions = (imageBase) => {
  return httpClient.post(`https://enterprise.zhihuituancan.com/ws/remote_function_call/`,
    {
      machine_id: -1,
      debug: true,
      timeout: 10, /// / websocket client接口运行超时时间，单位为s
      method_call_entity: {
        name: 'v2_localizeFood', /// //调用的function的名字
        params: [imageBase, '{"x":0,"y":0,"w":1,"h":1}']
      }
    }, {
      headers: {
        'content-type': 'application/json'
      }
    }).then(res => {
    if (res.statusText === 'OK') {
      return Promise.resolve(res.data.result);
    } else {
      return Promise.reject(new Error('切割接口异常'));
    }
    // console.log(res);
  });
};
